//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiSquareEditOutline,
  mdiDotsVertical,
  mdiChartTimelineVariant,
  mdiAccountOutline,
  mdiPencilOutline,
  mdiCogOutline,
} from '@mdi/js'

export default {
  setup() {
    const statusColor = {
      /* eslint-disable key-spacing */
      inactive: 'secondary',
      active: 'success',
      pending: 'warning',
      applied: 'info',
      /* eslint-enable key-spacing */
    }

    const role = {
      maintainer: { icon: mdiChartTimelineVariant, color: 'primary' },
      subscriber: { icon: mdiAccountOutline, color: 'warning' },
      editor: { icon: mdiPencilOutline, color: 'info' },
      author: { icon: mdiCogOutline, color: 'success' },
    }

    const userListData = [
      {
        avatar: '1.png',
        fullName: 'Joseph Wheeler',
        userName: '@gslixby0',
        primaryEmail: 'nuroani@icpair.com',
        role: 'maintainer',
        status: 'inactive',
      },
      {
        avatar: '2.png',
        fullName: 'May Lloyd',
        userName: '@hredmore1',
        primaryEmail: 'jeju@ma.co.uk',
        role: 'subscriber',
        status: 'active',
      },
      {
        avatar: '3.png',
        fullName: 'William Mckinney',
        userName: '@msicely2',
        primaryEmail: 'suumde@ha.co.uk',
        role: 'subscriber',
        status: 'pending',
      },
      {
        fullName: 'Isabel Briggs',
        userName: '@crisby3',
        primaryEmail: 'temiwiho@ohacma.gov',
        role: 'editor',
        status: 'active',
      },
      {
        avatar: '5.png',
        fullName: 'Warren Clarke',
        userName: '@mhurran4',
        primaryEmail: 'hirasles@zozzetkuv.edu',
        role: 'maintainer',
        status: 'inactive',
      },
      {
        avatar: '4.png',
        fullName: 'Adeline Bennett',
        userName: '@shalstead5',
        primaryEmail: 'boz@peh.co.uk',
        role: 'author',
        status: 'pending',
      },
      {
        fullName: 'Cristina Briggs',
        userName: '@bgallemore6',
        primaryEmail: 'temiwiho@ohacma.gov',
        role: 'editor',
        status: 'active',
      },
    ]

    const tableColumnHeaders = [
      { text: 'USER', value: 'fullName' },
      { text: 'EMAIL', value: 'primaryEmail' },
      { text: 'ROLE', value: 'role' },
      { text: 'STATUS', value: 'status' },
    ]

    return {
      userListData,
      statusColor,
      role,
      tableColumnHeaders,

      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
      },
    }
  },
}
